export default __webpack_public_path__ + "static/media/b6.bbc24da0.jpg";